import { usePageTitle } from '@/hooks/usePageTitle';
import MessageBoardPage from '../message-board/MessageBoardPage';

// Global Posts page - shows company-wide posts view
// This wraps MessageBoardPage with isGlobalView flag to display without project context
export function GlobalPostsPage() {
  usePageTitle('Posts');
  return <MessageBoardPage isGlobalView={true} />;
}

export default GlobalPostsPage;
